import * as React from "react";

export const IconCopy = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.66667 18.3333C1.20833 18.3333 0.815972 18.1701 0.489583 17.8438C0.163194 17.5174 0 17.125 0 16.6667L0 5H1.66667L1.66667 16.6667H10.8333V18.3333H1.66667ZM5 15C4.54167 15 4.14931 14.8368 3.82292 14.5104C3.49653 14.184 3.33333 13.7917 3.33333 13.3333L3.33333 1.66667C3.33333 1.20833 3.49653 0.815972 3.82292 0.489583C4.14931 0.163194 4.54167 0 5 0L10.8333 0L15.8333 5L15.8333 13.3333C15.8333 13.7917 15.6701 14.184 15.3437 14.5104C15.0174 14.8368 14.625 15 14.1667 15L5 15ZM10 5.83333L14.1667 5.83333L10 1.66667L10 5.83333Z"
      fill="currentColor"
    />
  </svg>
);
